import React from 'react';
import { TextBox } from '@progress/kendo-react-inputs';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FormFieldWrapper } from '../FormFieldWrapper';

interface FormTextBoxProps extends FieldRenderProps {
  isLoading?: boolean;
}

export const FormTextBox: React.FC<FormTextBoxProps> = fieldRenderProps => {
  const { isLoading } = fieldRenderProps;

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <TextBox
        onChange={fieldRenderProps.onChange}
        value={fieldRenderProps.value}
        name={fieldRenderProps.name}
        valid={fieldRenderProps.valid}
      />
    </FormFieldWrapper>
  );
};
